export default "__VITE_ASSET__6672QBje__"